import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[appClickNoPropagate]'
})
export class ClickNoPropagateDirective {

  @HostListener('click', ['$event'])
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onClick(event: any): void {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      event.stopPropagation()
  }
}
